const ATTACHMENT_WORD = /\b[a-z]*(?:attach|includ)[a-z]*\b/i;

export const renewalEmailWarnings = ({ subject, body, compose, includePreviousApplication, hasCertificate }) => {
  const missing = [];
  if (compose?.application_url && !body.includes(compose.application_url)) {
    missing.push("the application link");
  }
  if (compose?.application_number && !body.includes(compose.application_number)) {
    missing.push("the application number");
  }

  const warnings = [];
  if (missing.length > 0) {
    warnings.push(`The email is missing ${missing.join(" and ")}.`);
  }
  if (!includePreviousApplication && !hasCertificate) {
    const visibleBody = new DOMParser().parseFromString(body, "text/html").body.textContent || "";
    if (ATTACHMENT_WORD.test(`${subject || ""} ${visibleBody}`)) {
      warnings.push("The email mentions attaching or including something, but no files are attached.");
    }
  }
  return warnings;
};
